import { feeValue } from '../../../lib/numbers'
import {
  round2,
  stripeAchFee,
  stripeCardFee,
} from '../../../lib/sponsorPledgeFlowMath'

export function computeReviewFeeTotals({
  commitmentNum,
  opsAmount,
  adminFee,
  serviceFee,
}) {
  const c = Number(commitmentNum) || 0
  const adminAmt = feeValue(String(c || 0), adminFee) ?? 0
  const serviceAmt = feeValue(String(c || 0), serviceFee) ?? 0
  const opsNum = round2(Math.max(0, parseFloat(opsAmount) || 0))
  const reviewSubtotal = round2(c + opsNum)
  const preStripeForProcessing = round2(reviewSubtotal + adminAmt + serviceAmt)
  const achFee = stripeAchFee(preStripeForProcessing)
  const cardFee = stripeCardFee(preStripeForProcessing)
  const totalAch = round2(preStripeForProcessing + achFee)
  return {
    adminAmt,
    serviceAmt,
    opsNum,
    reviewSubtotal,
    preStripeForProcessing,
    achFee,
    cardFee,
    totalAch,
  }
}

export function computeVpfShares(vpfAmount) {
  const v = Number(vpfAmount) || 0
  const vpfVolunteerShare = round2(v / 2)
  const vpfOrgShare = round2(v - vpfVolunteerShare)
  return { vpfVolunteerShare, vpfOrgShare }
}
